"use client";

import type { ReactNode } from 'react';
import React from 'react';
import { CollapseContext } from './CollapseContext';
import { useCollapse } from './useCollapse';

export type CollapseProps = {
  children?: ReactNode | (({ isShowing }: { isShowing: boolean }) => ReactNode);
  id?: string;
  onRequestChange?: (isShowing: boolean) => void;
  isShowing?: boolean;
  defaultShowing?: boolean;
  disabled?: boolean;
};

export function Collapse({
  id: idProp,
  isShowing,
  onRequestChange,
  children,
  defaultShowing,
  disabled,
}: CollapseProps) {
  const result = useCollapse({
    id: idProp,
    isShowing,
    onRequestChange,
    defaultShowing,
    disabled,
  });

  return (
    // @ts-expect-error FIXME(strictNullChecks)
    <CollapseContext.Provider value={result}>
      {typeof children === 'function'
        // @ts-expect-error FIXME(strictNullChecks)
        ? children({ isShowing: result.isShowing })
        : children}
    </CollapseContext.Provider>
  );
}
